import {  Scene } from 'three';
import { createPreloader } from '/src/World/systems/preloader';



function createScene() {
  const scene = new Scene();
  const preloader = createPreloader();

  

  return scene;
}

export { createScene };